import { BUILD_ID } from './appVersion';

let registration = null;
let onUpdateFound = null;

export function setUpdateCallback(cb) {
  onUpdateFound = cb;
}

export async function register() {
  if (!('serviceWorker' in navigator)) return;

  try {
    // The build id rides along in the query string for two reasons: it makes the
    // script URL byte-different on every deploy (so the browser always treats it
    // as a new worker, even where sw.js itself is unchanged), and sw.js reads it
    // back to name its cache, so the previous build's cache is dropped on
    // activate instead of accumulating under one static name.
    registration = await navigator.serviceWorker.register(`/sw.js?v=${encodeURIComponent(BUILD_ID)}`);

    // Already a waiting worker from a previous visit
    if (registration.waiting) {
      onUpdateFound?.('waiting');
    }

    registration.addEventListener('updatefound', () => {
      const newWorker = registration.installing;
      if (!newWorker) return;

      newWorker.addEventListener('statechange', () => {
        if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
          // New version installed, waiting to activate
          onUpdateFound?.('waiting');
        }
      });
    });

    // When another tab activates the update, reload this tab
    let refreshing = false;
    navigator.serviceWorker.addEventListener('controllerchange', () => {
      if (refreshing) return;
      refreshing = true;
      window.location.reload();
    });

  } catch (err) {
    console.warn('SW registration failed:', err);
  }
}

export async function checkForUpdate() {
  if (!registration) return 'no-sw';
  try {
    await registration.update();

    // If a new worker started installing, wait for it to finish
    const installing = registration.installing;
    if (installing) {
      return new Promise((resolve) => {
        installing.addEventListener('statechange', () => {
          if (installing.state === 'installed') resolve('update-available');
        });
        // Timeout fallback — install shouldn't take more than 10s
        setTimeout(() => resolve(registration.waiting ? 'update-available' : 'up-to-date'), 10000);
      });
    }

    // Check if a worker is already waiting (installed between visits)
    if (registration.waiting) return 'update-available';

    return 'up-to-date';
  } catch (err) {
    console.warn('Update check failed:', err);
    return navigator.onLine ? 'error' : 'offline';
  }
}

export function applyUpdate() {
  const waiting = registration?.waiting;
  if (!waiting) return;
  waiting.postMessage({ type: 'SKIP_WAITING' });

  // iOS Safari fallback: controllerchange doesn't always fire in standalone PWA mode.
  // Force reload after a short delay if the event hasn't triggered.
  setTimeout(() => {
    window.location.reload();
  }, 2000);
}
